import { BasicAreaCharts } from '../../../../common/charts/BasicAreaCharts';
import { ZoomableLineChart } from '../components/ZoomableLineChart';

// Area chart colors
export const AREA_CHART_COLORS: string[] = ['#FA8073', '#84C57D'];

// Chart titles that should use area charts
export const AREA_CHART_TITLES = {
  MEMORY: 'Memory',
  FILESYSTEM_KEYWORD: 'filesystem',
} as const;

/**
 * Determines if a chart should be rendered as an area chart based on its title
 * @param chartTitle - The title of the chart
 * @returns true if the chart should be an area chart, false otherwise
 */
export const isAreaChart = (chartTitle?: string): boolean => {
  if (!chartTitle) return false;
  return (
    chartTitle === AREA_CHART_TITLES.MEMORY ||
    chartTitle.toLowerCase().includes(AREA_CHART_TITLES.FILESYSTEM_KEYWORD)
  );
};

/**
 * Gets the appropriate chart component and props based on chart title
 * @param chartTitle - The title of the chart
 * @returns Object containing the chart component, type, and props
 */
export const getChartComponent = (chartTitle?: string) => {
  if (isAreaChart(chartTitle)) {
    return {
      chart: BasicAreaCharts,
      type: 'area' as const,
      props: { customColor: AREA_CHART_COLORS },
    };
  }

  return {
    chart: ZoomableLineChart,
    type: 'line' as const,
    props: {},
  };
};
